import type IntlService from 'ember-intl/services/intl';

/**
 * Formats a transaction date string to a localized date display
 *
 * @param dateString - ISO date string from transaction.transactionDate
 * @param intl - Ember Intl service for localization
 * @returns Formatted date string (e.g., "12/25/2025")
 */
export function formatTransactionDate(dateString: string, intl: IntlService): string {
  const date = new Date(dateString);
  return intl.formatDate(date, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
}

/**
 * Formats a transaction amount from cents to localized currency display
 *
 * @param amountInCents - Transaction amount in cents
 * @param intl - Ember Intl service for localization
 * @returns Formatted currency string (e.g., "$12.50")
 */
export function formatTransactionAmount(amountInCents: number, intl: IntlService): string {
  const amountInDollars = amountInCents / 100;
  return intl.formatNumber(Math.abs(amountInDollars), {
    style: 'currency',
    currency: 'USD',
  });
}
